import {EScene} from '@/types/scene.types'
import {useTracking} from '@repo/shared/Tracking/Tracking.hooks'
import {getTrackingGameMode} from '@repo/shared/Tracking/Tracking.utils'
import {useWakeLockContext} from '@repo/shared/WakeLockProvider'
import {useAtomValue} from 'jotai'
import {useEffect} from 'react'
import {useTransitionState} from 'react-transition-state'
import {gameCodeState, gameModeState, sceneState} from '../Store/atoms'
import ScoreboardParty from './Scoreboard.party'
import ScoreboardSingleplayer from './Scoreboard.singleplayer'

const ScoreboardScreen = () => {
  const {requestWakeLock} = useWakeLockContext()
  const {trackScreenEnter} = useTracking()

  const gameMode = useAtomValue(gameModeState)
  const scene = useAtomValue(sceneState)
  const gameCode = useAtomValue(gameCodeState)

  const [state, toggle] = useTransitionState({
    timeout: {
      enter: 0,
      exit: 200, // <-- time allowed for the exit animation
    },
  })

  /**
   * If the scene is pre-lobby, toggle the transition
   */
  useEffect(() => {
    if (scene === EScene.SCOREBOARD) {
      toggle(true)

      trackScreenEnter({
        screenIdentifier: 'scoreboard',
        abstractPath: '/scoreboard',
        meta: {
          gameCode: gameCode?.toString() ?? undefined,
          gameMode: getTrackingGameMode(gameMode),
        },
      })
    } else {
      toggle(false)
    }
  }, [scene])

  useEffect(() => {
    requestWakeLock()
  }, [requestWakeLock])

  /**
   * If the status is exited, don't render anything
   */
  if (state.status === 'exited') {
    return null
  }

  return gameMode === 'single_player' ? (
    <ScoreboardSingleplayer transitionStatus={state.status} />
  ) : (
    <ScoreboardParty transitionStatus={state.status} />
  )
}

export default ScoreboardScreen
